import {
  ApiResponse,
  Curriculum,
  DuplicateCurriculumPayload,
  DuplicateCurriculumResponse,
} from "@twinkltech/curriculum-architect-domain-hooks";

import { LoadingModal } from "@/pages/LoadingModal/LoadingModal";

import { SchoolDuplicateCurriculumModal } from "./components/SchoolDuplicateCurriculumModal/SchoolDuplicateCurriculumModal";
import { IndividualDuplicateCurriculumModal } from "./IndividualDuplicateCurriculumModal/IndividualDuplicateCurriculumModal";

export const DuplicateCurriculumModal = ({
  curriculum,
  error,
  isLoading = false,
  isSchoolAccount = false,
  onDuplicate,
  open,
  setOpen,
}: {
  curriculum: Curriculum;
  error: Error | null;
  isLoading?: boolean;
  isSchoolAccount?: boolean;
  onDuplicate: (params: {
    payload: DuplicateCurriculumPayload;
  }) => ApiResponse<DuplicateCurriculumResponse>;
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  // NOTE: Very important for the school version of the modal. Stops the defaults being populated before the data is loaded.
  // If this is done after, the access confirmation prompt triggers and disables the modal form fields.
  if (isLoading) {
    return (
      <LoadingModal open={open} width="md" onClose={() => setOpen(false)} />
    );
  }

  return isSchoolAccount ? (
    <SchoolDuplicateCurriculumModal
      curriculum={curriculum}
      error={error}
      isLoading={isLoading}
      open={open}
      setOpen={setOpen}
      onSubmit={onDuplicate}
    />
  ) : (
    <IndividualDuplicateCurriculumModal
      curriculum={curriculum}
      error={error}
      loading={isLoading}
      open={open}
      setOpen={setOpen}
      onDuplicate={onDuplicate}
    />
  );
};
